import React from 'react';
import { Eyebrow, Section } from './Section';
import { ComparisonTable } from './ComparisonTable';
import { transformationRows } from '../data/comparisons';
export function Transformation() {
  return <Section tone="creme" labelledBy="transformation-title" data-id="element-272" data-mp="mlv04khqq2x6">
      <Eyebrow data-id="element-273" data-mp="moh5qel2m8cr">Ce qui change</Eyebrow>
      <h2 id="transformation-title" className="max-w-3xl font-serif text-3xl font-semibold leading-[1.15] text-graphite md:text-[2.75rem]" data-id="element-274" data-mp="rlhdctxkjj5z">
        De la séance improvisée au parcours qui a un cap
      </h2>

      <div className="mt-12" data-id="element-275" data-mp="11hu6nqp7bv07">
        <ComparisonTable rows={transformationRows} beforeLabel="Sans cadre" afterLabel="Avec la méthode CAP™" caption="Comparaison entre une pratique sans cadre et la méthode CAP" data-id="element-276" data-mp="11h2c8j7cc3bi" />
      </div>
    </Section>;
}